import { Fragment, useEffect, useState } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import Filters from './containers/Filters'
import NewForum from './containers/NewForum'
import { Watchdog } from '@Techedge/smart-shared'
import { LuxIcon, Color } from '@lux/wardrobe-lib'
import NewActivity from './containers/NewActivity'
import NewResource from './containers/NewResource'
import SavePicture from './containers/SavePicture'
import NewQuickLink from './containers/NewQuickLink'
import NewsExecution from './containers/NewsExecution'
import { locale as initialLocale } from '@/root.component'
import TaskCommunicationExecution from './containers/TaskCommunicationExecution'
import { ability, AbilityContext, ModalsType } from '@Techedge/digitalportal-shared'
import {
    importMessages,
    LocaleMessages,
    SmartlyIntlProvider,
} from './../app/utils/localization/intlHelper'
import './App.scss'
import NewAlbum from './containers/NewAlbum'
import NewVirtualStorePackage from './containers/NewVirtualStorePackage'
import VisitExecution from './containers/VisitExecution'
import NewSurveyTask from './containers/NewSurveyTask'
import Grsd from './containers/Grsd'

export const App = (props: any) => {
    const { modalType, loading } = props

    const [locale, setLocale] = useState<string>(initialLocale)
    const [messages, setMessages] = useState<LocaleMessages | null>(null)

    useEffect(() => {
        setLocale(initialLocale)
        moment.locale(initialLocale)
        return () => {
            document.body.style.overflow = 'unset'
        }
    }, [])

    useEffect(() => {
        if (props?.language && props?.dictionary) {
            setLocale(props.language)
            moment.locale(props.language)
            importMessages(props.language).then(() => {
                setMessages(props.dictionary)
            })
        }
    }, [props?.language, props?.dictionary])

    useEffect(() => {
        // Hide body scrollbar, restored in row 74
        if (modalType) document.body.style.overflow = 'hidden'
    }, [modalType])

    const getModal = () => {
        switch (modalType) {
            case ModalsType.NEW_ACTIVITY:
                return <NewActivity />
            case ModalsType.NEW_SURVEY_TASK:
                return <NewSurveyTask />
            case ModalsType.NEWS_EXECUTION:
                return <NewsExecution />
            case ModalsType.TASK_EXECUTION:
                return <TaskCommunicationExecution />
            case ModalsType.VISIT_EXECUTION:
                return <VisitExecution />
            case ModalsType.FILTERS:
                return <Filters />
            case ModalsType.NEW_RESOURCE:
                return <NewResource />
            case ModalsType.NEW_FORUM:
                return <NewForum />
            case ModalsType.NEW_QUICK_LINK:
                return <NewQuickLink />
            case ModalsType.SAVE_PICTURE:
                return <SavePicture />
            case ModalsType.NEW_ALBUM:
                return <NewAlbum />
            case ModalsType.NEW_VIRTUAL_STORE:
                return <NewVirtualStorePackage />
            case ModalsType.GRSD:
                return <Grsd />
            default:
                // Restore body scrollbar
                document.body.style.overflow = 'unset'
                return <Fragment></Fragment>
        }
    }

    return (
        <SmartlyIntlProvider locale={locale} messages={messages}>
            <AbilityContext.Provider value={ability}>
                {!!messages && (
                    <Watchdog providerName="MODALS" userProfile={props.userProfiles[0]?.profile}>
                        <div id="smart-modals">
                            {loading && (
                                <div className="smart-modals--loading">
                                    <LuxIcon icon="loading" color={Color.WHITE} />
                                </div>
                            )}
                            {getModal()}
                        </div>
                    </Watchdog>
                )}
            </AbilityContext.Provider>
        </SmartlyIntlProvider>
    )
}

const mapStateToProps = (state: any) => ({
    modalType: state.layoutReducer.modals.type,
    loading: state.layoutReducer.modals.props.loading,
    language: state.userReducer.user.language,
    dictionary: state.userReducer.user.dictionary,
    userProfiles: state.userReducer.user.application_profiles || [],
})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(App)
